/**
 * Enables protected subscriptions only in an explicitly opted-in app build.
 * Generic notification realtime is independent of this release gate.
 */
export const isCommunicationsRealtimeEnabled = (): boolean =>
  import.meta.env.VITE_COMMUNICATIONS_REALTIME_ENABLED === 'true';
